import { isGlobalFeatureEnabled } from "owa-feature-flags";
import getIsSearchTableShown from "./getIsSearchTableShown";

/**
 * Whether the legacy search header (pre search-ribbon) is rendered directly above the Mail List
 * and Reading Pane. The panes drop their top inset in that case so they attach to the header.
 */
export default function getIsLegacySearchHeaderShown(): boolean {
    return getIsSearchTableShown() && !isGlobalFeatureEnabled("sea-searchRibbon");
}
